import React, { useEffect, useState } from "react";
import API from "../api/Api";
const ProjectFilters = ({ onFilterChange }) => {
const initialState = {
  status: "",
  department: "",
  min: "",
  max: "",
  limit: 10
};

  const [filters, setFilters] = useState(initialState);
  const [departments, setDepartments] = useState([]);

  // HANDLE INPUT
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  // APPLY FILTERS
  const applyFilters = () => {
    onFilterChange({
      ...filters,
      status: filters.status || "pending"
    });
  };

  // RESET
  const resetFilters = () => {
    setFilters(initialState);
    onFilterChange({ status: "pending" });
  };

  // FETCH DEPARTMENTS
useEffect(() => {
  API.get("/all_departments")
    .then((res) => {
      if (res.data.success) {
        setDepartments(res.data.data);
      }
      console.log(res.data.data);
    })
    .catch((err) => console.error(err));
}, []);

  return (
    <div className="card shadow-sm border-0 rounded-4">
      <div className="card-body">

        <h6 className="fw-semibold mb-4">🔍 Filter Projects</h6>

        {/* STATUS */}
        <div className="mb-3">
          <select
            name="status"
            className="form-control"
            value={filters.status}
            onChange={handleChange}
          >
            <option value="">Select Status</option>
            <option value="pending">Pending</option>
            <option value="ongoing">Ongoing</option>
            <option value="completed">Completed</option>
          </select>
        </div>

        {/* DEPARTMENT */}
        <div className="mb-3">
          <select
            name="department"
            className="form-control"
            value={filters.department}
            onChange={handleChange}
          >
            <option value="">Select Department</option>
            {departments.map((d) => (
              <option
                key={d.department_id}
                value={d.department.trim()}
              >
                {d.department}
              </option>
            ))}
          </select>
        </div>
{/* PAGE SIZE */}
<div className="mb-3">
  <select
    name="limit"
    className="form-control"
    value={filters.limit}
    onChange={handleChange}
  >
    <option value="5">Show 5 Projects</option>
    <option value="10">Show 10 Projects</option>
    <option value="20">Show 20 Projects</option>
    <option value="50">Show 50 Projects</option>
    <option value="100">Show 100 Projects</option>
  </select>
</div>
        {/* FUND RANGE */}
        {/* <div className="mb-4">
          <label className="small text-muted">Funding Range (₹)</label>
          <div className="d-flex gap-2">
            <input
              className="form-control"
              placeholder="Min"
              name="min"
              value={filters.min}
              onChange={handleChange}
            />
            <input
              className="form-control"
              placeholder="Max"
              name="max"
              value={filters.max}
              onChange={handleChange}
            />
          </div>
        </div> */}

        {/* BUTTONS */}
        <div className="d-flex gap-2">
          <button className="btn btn-primary w-100" onClick={applyFilters}>
            Apply
          </button>
          <button className="btn btn-outline-secondary w-100" onClick={resetFilters}>
            Reset
          </button>
        </div>

      </div>
    </div>
  );
};

export default ProjectFilters;
